import { BaseSymbolTypes } from "../services/symbolService";
import { RevealUncoverTier, getRevealUncoverTier } from "@spawn/reveal";
import { IGameNetworkState } from "./networkState";

export function hasConsecutiveMysteries(arr: string[], count: number): boolean {
	let consecutive = 0;
	for (const symbol of arr) {
		if (symbol === BaseSymbolTypes.Mystery) {
			consecutive++;
			if (consecutive >= count) {
				return true;
			}
		} else {
			consecutive = 0;
		}
	}
	return false;
}

export function getWonFGScatterCount(reveal: IGameNetworkState["reveal"]): number {
	return reveal?.symbols?.filter((symbol) => symbol.symbol === BaseSymbolTypes.ScatterFG).length ?? 0;
}

export function getUncoverTierFromWinFactor(winFactor: number | undefined): RevealUncoverTier {
	return getRevealUncoverTier(Number.isFinite(winFactor) ? Number(winFactor) : 1);
}
